"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureAnalyticsLogger = exports.log = exports.logImmediate = void 0;
const uuid_1 = require("uuid");
const defaults = {
    url: "https://api.hackthenorth.com/analytics",
    bufferSize: 50,
    uuid: uuid_1.v4(),
};
class BatchedLogger {
    constructor(config = defaults) {
        this.toLog = [];
        this.lastStream = {};
        this.config = config;
        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "hidden") {
                this.encodeAndSend();
            }
        });
    }
    configure(config) {
        this.config = Object.assign(Object.assign({}, this.config), config);
    }
    encodeAndSend(data) {
        if (this.toLog.length > 0) {
            navigator.sendBeacon(this.config.url, JSON.stringify({
                uuid: this.config.uuid,
                data: data !== null && data !== void 0 ? data : this.toLog.map((_a) => {
                    var { startTime } = _a, x = __rest(_a, ["startTime"]);
                    return (Object.assign(Object.assign({}, x), { start_time: startTime }));
                }),
            }));
            this.toLog = [];
        }
    }
    logImmediate(data) {
        this.encodeAndSend([data]);
    }
    log(data) {
        var _a;
        this.toLog.push(Object.assign(Object.assign({}, data), { stream: data.stream || "default", previous: (_a = this.lastStream[data.stream]) !== null && _a !== void 0 ? _a : "" }));
        this.lastStream[data.stream] = data.uuid;
        if (this.toLog.length > this.config.bufferSize) {
            this.encodeAndSend();
        }
    }
}
const BatchedLoggerInstance = new BatchedLogger();
function logImmediate(data) {
    return;
}
exports.logImmediate = logImmediate;
function log(data) {
    return BatchedLoggerInstance.log(data);
}
exports.log = log;
function configureAnalyticsLogger(config) {
    return BatchedLoggerInstance.configure(config);
}
exports.configureAnalyticsLogger = configureAnalyticsLogger;
